import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  AdministrationCarrierRegisteredService,
  CarrierLoadsHistoryBaseCarrierLoadsHistoryCustomerModel,
  CarrierLoadsHistoryBaseCarrierLoadsHistoryModel,
  CarrierRegisteredBoardModel,
  CarrierRegisteredBoardRequest,
  AdminCarrierListModel,
  AdminCarrierBoardSortRequest,
  PageModelAdminCarrierListModel,
  AdminCarrierListRequest
} from '../autogenerated';
import { PAGE, SIZE, REQUEST_OPTIONS } from '../constants';
import { RequestOptionsJsonType } from '../types';

@Injectable({ providedIn: 'root' })
export class AdministrationCarrierRegisteredApiService {
  constructor(private apiService: AdministrationCarrierRegisteredService) {}

  public historyCustomers(carrierId: string, page: number = PAGE, size: number = SIZE, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<CarrierLoadsHistoryBaseCarrierLoadsHistoryCustomerModel> {
    return this.apiService.adminCarrierHistoryCustomers(carrierId, page, size, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public historyLoads(carrierId: string, customerId?: string, page: number = PAGE, size: number = SIZE, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<CarrierLoadsHistoryBaseCarrierLoadsHistoryModel> {
    return this.apiService.adminCarrierHistoryLoads(carrierId, customerId, page, size, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public board(body: CarrierRegisteredBoardRequest, page: number = PAGE, size: number = SIZE, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<CarrierRegisteredBoardModel[]> {
    return this.apiService.adminCarrierRegisteredBoard(body, page, size, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public setBoardSort(body: AdminCarrierBoardSortRequest, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<AdminCarrierListModel> {
    return this.apiService.adminCarrierRegisteredEditBoardSortOrder(body, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public list(body: AdminCarrierListRequest, page: number = PAGE, size: number = SIZE, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<PageModelAdminCarrierListModel> {
    return this.apiService.adminCarrierRegisteredList(body, page, size, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
}
